import { commonEn } from "./locales/common";
import { shopEn } from "./locales/shop";
import { adminEn } from "./locales/admin";
import { franchiseEn } from "./locales/franchise";
import { packagesEn } from "./locales/packages";
import { contactEn } from "./locales/contact";
import { checkoutEn } from "./locales/checkout";
import { panelEn } from "./locales/panel";
import { membershipEn } from "./locales/membership";

/**
 * Bundle es/en.
 *
 * Estrategia heredada del sistema actual: las CLAVES son el texto en
 * español (natural keys). El español es la fuente, así que `t("Texto")`
 * devuelve "Texto" cuando no hay traducción, y añadir un idioma es
 * llenar su mapa. Por eso `es` va vacío.
 *
 * Los mapas del inglés se parten POR ÁREA en `locales/`. Un solo archivo
 * gigante es un cuello de botella: cada pantalla nueva lo toca y todo el
 * mundo choca en la misma línea.
 */
export const es: Record<string, string> = {};

export const en: Record<string, string> = {
  ...commonEn,
  ...shopEn,
  ...adminEn,
  ...franchiseEn,
  ...packagesEn,
  ...contactEn,
  ...checkoutEn,
  ...panelEn,
  ...membershipEn,
};

export const resources = {
  es: { translation: es },
  en: { translation: en },
} as const;
